import { DatagridConfigurable, List, SelectField, TextField } from 'react-admin';
import { RegionResource } from '../../Entities/Region';
import { ReactElement } from 'react';
import { CURRENCY_CODE_CHOICES } from './utils';

export default function RegionList(): ReactElement {
  return (
    <List<RegionResource> perPage={25}>
      <DatagridConfigurable>
        <TextField source="id" />
        <TextField label="Name" source="attributes.name" />
        <SelectField
          choices={CURRENCY_CODE_CHOICES}
          label="Currency Code"
          source="attributes.currency_code"
        />
        <TextField label="Domain" source="attributes.domain" />
      </DatagridConfigurable>
    </List>
  );
}
